export default class OrderError extends Error {
  errors: any
  code: any
  params: any
  refCode: any

  constructor(message: string) {
    super(message)
    this.name = 'OrderError'
  }
}
